import React, { useState } from 'react';
import { DashboardProvider, useDashboard } from '../contexts/DashboardContext';
import DashboardToolbar from '../components/dashboard/DashboardToolbar';
import WidgetGrid from '../components/dashboard/WidgetGrid';
import WidgetCatalog from '../components/dashboard/WidgetCatalog';

const DashboardContent: React.FC = () => {
  const { loading, editMode } = useDashboard();
  const [catalogOpen, setCatalogOpen] = useState(false);

  if (loading) {
    return (
      <div style={{
        display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '60vh',
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{
            width: '40px', height: '40px',
            border: '3px solid var(--border-light)',
            borderTopColor: 'var(--color-primary-600)',
            borderRadius: '50%',
            animation: 'spin 0.6s linear infinite',
            margin: '0 auto var(--space-4)',
          }} />
          <p style={{ fontSize: 'var(--text-sm)', color: 'var(--text-secondary)' }}>
            Carregando dashboard...
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      animation: 'fadeIn 0.3s ease-out',
      padding: 'var(--space-6) 0',
      width: '100%',
      minHeight: '100vh',
      boxSizing: 'border-box'
    }}>
      <DashboardToolbar onOpenCatalog={() => setCatalogOpen(true)} />

      {/* Edit mode indicator */}
      {editMode && (
        <div style={{
          background: 'rgba(99, 102, 241, 0.08)',
          border: '1px dashed rgba(99, 102, 241, 0.3)',
          borderRadius: 'var(--radius-lg)',
          padding: 'var(--space-2) var(--space-4)',
          marginBottom: 'var(--space-4)',
          marginLeft: 'var(--space-4)',
          marginRight: 'var(--space-4)',
          fontSize: 'var(--text-sm)',
          color: 'var(--color-primary-600)',
          textAlign: 'center',
          maxWidth: '1600px',
          marginInline: 'auto',
        }}>
          Modo de edicao ativo — arraste widgets para reposicionar, redimensione pelas bordas
        </div>
      )}

      <WidgetGrid />
      <WidgetCatalog isOpen={catalogOpen} onClose={() => setCatalogOpen(false)} />

      <style>{`
        @keyframes fadeIn {
          from { opacity: 0; transform: translateY(10px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
        .list-item:hover {
          background: var(--bg-tertiary);
        }

        /* react-grid-layout customizations */
        .widget-grid {
          width: 100% !important;
        }
        .widget-grid .react-grid-item {
          transition: all 200ms ease;
          box-sizing: border-box;
        }
        .widget-grid .react-grid-item.react-draggable-dragging {
          transition: none;
          z-index: 100;
          opacity: 0.9;
          box-shadow: 0 20px 40px rgba(0,0,0,0.3);
        }
        .widget-grid .react-grid-placeholder {
          background: rgba(99, 102, 241, 0.15) !important;
          border: 2px dashed rgba(99, 102, 241, 0.4) !important;
          border-radius: var(--radius-xl) !important;
          opacity: 1 !important;
        }
        .widget-grid .react-resizable-handle {
          background: none !important;
        }
        .widget-grid .react-resizable-handle::after {
          border-color: var(--text-tertiary) !important;
          width: 8px !important;
          height: 8px !important;
        }

        /* Responsividade adicional */
        @media (max-width: 768px) {
          .widget-grid .react-grid-item {
            margin-bottom: var(--space-2) !important;
          }
        }

        /* Evitar overflow horizontal */
        .widget-grid,
        .widget-grid > div,
        .widget-grid .react-grid-item {
          max-width: 100%;
          overflow-x: hidden;
        }
      `}</style>
    </div>
  );
};

const Dashboard: React.FC = () => {
  return (
    <DashboardProvider>
      <DashboardContent />
    </DashboardProvider>
  );
};

export default Dashboard;
